(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('InfectionController', InfectionController);

    InfectionController.$inject = ['$compile', '$scope', '$state', 'Infection', 'InfectionSearch', '$q', 'DTColumnBuilder', 'entity',
        'DTOptionsBuilder', 'GUIUtils', '$filter'];

    function InfectionController($compile, $scope, $state, Infection, InfectionSearch, $q, DTColumnBuilder, entity,
                                 DTOptionsBuilder, GUIUtils, $filter) {
        var vm = this;

        vm.patient = entity;
        vm.infections = [];
        vm.search = search;
        vm.dtInstance = {};

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                Infection.getAllByPatientId({id: vm.patient.id}, function (result) {
                    vm.infections = result;
                    defer.resolve(result);
                });
            } else {
                defer.resolve($filter('filter')(vm.infections, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap().withDOM('tip').withOption('fnRowCallback',
            function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                $compile(nRow)($scope);
            });

        vm.dtColumns = [
            DTColumnBuilder.newColumn('suspectedDate').withTitle('Suspected').renderWith(function (data, type, full) {
                return data ? moment(data).format("MM/DD/YYYY") : "";
            }),
            DTColumnBuilder.newColumn('confirmedDate').withTitle('Confirmed').renderWith(function (data, type, full) {
                return data ? moment(data).format("MM/DD/YYYY") : "";
            }),
            DTColumnBuilder.newColumn('accessCondition').withTitle('Access Condition').renderWith(function (data, type, full) {
                return data ? 'Y' : 'N';
            }),
            DTColumnBuilder.newColumn('hospitalization').withTitle('Hospital').renderWith(function (data, type, full) {
                return data ? 'Y' : 'N';
            }),
            DTColumnBuilder.newColumn('hospitalizationDate').withTitle('Hospital Date').renderWith(function (data, type, full) {
                return data ? moment(data).format("MM/DD/YYYY") : "";
            }),
            DTColumnBuilder.newColumn('aStarted').withTitle('Antimicrobial Started').renderWith(function (data, type, full) {
                return data ? 'Y' : 'N';
            }),
            DTColumnBuilder.newColumn('aStartedDate').withTitle('Antimicrobial Started Date').renderWith(function (data, type, full) {
                return data ? moment(data).format("MM/DD/YYYY") : "";
            }),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                .renderWith(actionsHtml)
        ];

        function actionsHtml(data, type, full, meta) {
            var stButtons = '';

            stButtons += '<a class="btn-sm btn-warning" ui-sref="infection.view({iid:' + data.id + '})">' +
                '   <i class="fa fa-edit"></i></a>&nbsp;';

            if (vm.patient.status) {
                stButtons += '<a class="btn-sm btn-danger" ui-sref="infection.delete({iid:' + data.id + '})">' +
                    '   <i class="fa fa-trash"></i></a>';
            }

            return stButtons;
        }

        function search() {
            vm.dtInstance.reloadData();
        }

    }
})();
